const CLIENT_SECRET = process.env.REACT_APP_WS02_CLIENT_SECRET as string;
const AUTH_END_POINT = process.env.REACT_APP_WS02_END_POINT as string;
const XSM_ORIGIN = process.env.REACT_APP_XSM_ORIGIN as string;

const CLIENT_URL = process.env.REACT_APP_WS02_CLIENT_KEY as string;
const XSM_BASE_URL = process.env.REACT_APP_XSM_API_BASE_URL as string;
const REACT_AUTH_ENDPOINT = process.env.REACT_APP_FRONTEND_BASE_URL as string;
const SCOPE = process.env.REACT_APP_SCOPE as string;
const USER_DOMAIN = process.env.REACT_APP_USER_DOMAIN as string;
const XSM_APPLICATION = process.env.REACT_APP_XSM_APPLICATION as string;

const COMMON_CALLBACK_URL = process.env.REACT_APP_COMMON_CALLBACK_URL as string;
const MASTER_CALLBACK_URL = process.env.REACT_APP_MASTER_CALLBACK_URL as string;
const PARTNER_CALLBACK_URL = process.env
  .REACT_APP_PARTNER_CALLBACK_URL as string;
const SYS_ADMIN_CALLBACK_URL = process.env
  .REACT_APP_SYS_ADMIN_CALLBACK_URL as string;
const XSM_MASTER_SUB_DOMAIN =
  process.env.REACT_APP_XSM_MASTER_SUB_DOMAIN as string;
const XSM_PARTNER_SUB_DOMAIN =
  process.env.REACT_APP_XSM_PARTNER_SUB_DOMAIN as string;
const XSM_SYSTEM_SUB_DOMAIN =
  process.env.REACT_APP_XSM_SYSTEM_SUB_DOMAIN as string;

export {
  AUTH_END_POINT,
  CLIENT_URL,
  REACT_AUTH_ENDPOINT,
  XSM_BASE_URL,
  XSM_APPLICATION,
  XSM_ORIGIN,
  CLIENT_SECRET,
  USER_DOMAIN,
  SCOPE,
  MASTER_CALLBACK_URL,
  PARTNER_CALLBACK_URL,
  SYS_ADMIN_CALLBACK_URL,
  COMMON_CALLBACK_URL,
  XSM_MASTER_SUB_DOMAIN,
  XSM_PARTNER_SUB_DOMAIN,
  XSM_SYSTEM_SUB_DOMAIN,
};
